import { breakpoints } from '@99designs/common/core/settings';
import React from 'react';
import { default as ReactResponsive } from 'react-responsive';

type Breakpoint = 'small' | 'medium' | 'normal' | 'large';
interface Props {
    min?: Breakpoint;
    max?: Breakpoint;
}

const Responsive: React.SFC<Props> = ({ min, max, children }) => {
    const sizes: { minWidth?: number; maxWidth?: number } = {};

    if (min) {
        sizes.minWidth = breakpoints[min][0]!;
    }

    if (max) {
        sizes.maxWidth = breakpoints[max][1]!;
    }

    return <ReactResponsive {...sizes} children={children} />;
};

export default Responsive;
